import { camelCase } from './camelCase';

export const setErrors = (error, state = {}) => {
  if (!error) {
    return state;
  }
  if (error.modelState) {
    return error.modelState;
  }
  if (error.name === 'ValidationError') {
    return {
      [error.path]: error.errors || '',
    };
  }
  if (typeof error === 'object') {
    const errorFormatted = state;
    Object.keys(error).forEach((key) => {
      errorFormatted[camelCase(key)] = error[key];
    });
    return errorFormatted;
  }

  return state;
};
